import type { FormConfig, FormModel } from '@acme/foundation';
import { getByPath } from '@acme/foundation';
import { useEffect, useRef } from 'react';
import type { ApplicationFormationFormCtx } from '../model/formConfig';

export function useFormHydration(
  form: FormModel<ApplicationFormationFormCtx>,
  formConfig: FormConfig<ApplicationFormationFormCtx>,
  defaultData: ApplicationFormationFormCtx | undefined,
  applicationId: string | undefined
) {
  const hasHydrated = useRef(false);
  const lastApplicationId = useRef<string | undefined>(undefined);

  useEffect(() => {
    if (!applicationId) {
      hasHydrated.current = false;
      return;
    }
    if (lastApplicationId.current !== applicationId) {
      lastApplicationId.current = applicationId;
      hasHydrated.current = false;
    }
    if (!defaultData || hasHydrated.current) return;
    hasHydrated.current = true;
    const data = defaultData;
    for (const c of formConfig.controls) {
      if (!c.read || c.id === '__submitKind') continue;
      const v =
        typeof c.read === 'function'
          ? (c.read as (ctx: ApplicationFormationFormCtx) => unknown)(data)
          : getByPath(data, c.read);
      form.onChange(c.id, v);
    }
  }, [applicationId, defaultData, formConfig.controls, form]);
}
